/**
 * Check if the URLSearchParams is empty.
 * @param {URLSearchParams} params - The URLSearchParams to check.
 * @returns {boolean} True if the URLSearchParams is empty, false otherwise.
 */
const isEmptyURLSearchParams = (params) => {
    if (typeof params.size === 'number') {
        return params.size === 0;
    }

    return params.toString() === '';
};

/**
 * Stringify the search params and adds `?` prefix.
 * @param {{ [key: string]: unknown } | URLSearchParams} params - The search params to stringify.
 * @returns {string} The stringified search params.
 */
export const stringifySearchParams = (params) => {
    const searchParams = new URLSearchParams(params);
    const isInitiallyEmpty = isEmptyURLSearchParams(searchParams);
    if (isInitiallyEmpty) {
        return '';
    }

    const isURLSearchParamsInstance = params instanceof URLSearchParams;
    if (isURLSearchParamsInstance) {
        return `?${searchParams.toString()}`;
    }

    Object.entries(params).forEach(([key, value]) => {
        if (typeof value === 'undefined' || value === null) {
            searchParams.delete(key);
            return;
        }

        if (!Array.isArray(value)) {
            return;
        }

        searchParams.delete(key);
        value.forEach((item) => {
            searchParams.append(key, item);
        });
    });

    const isEmptyAfterProcessing = isEmptyURLSearchParams(searchParams);
    if (isEmptyAfterProcessing) {
        return '';
    }

    return `?${searchParams}`;
};
